// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","socials":"Footer_socials__bqeqA","social_media":"Footer_social_media__MyFnU"};